export type Env = "TAX_GURU_BACKEND_URL"

export const readEnv = (part: Env): string | undefined => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return process.env[`REACT_APP_${part}`] || window[part]
}